<template>
  <div
    ref="hiddenPages"
    class="hidde-pages-container">
    <BaseSvg
      customClass="three-dots-icon"
      :src="MoreIcon"
      alt="three-dots"
      @click="showPagesContainer = !showPagesContainer" />
    <span
      v-if="showPagesContainer"
      class="pages-container"
      :class="props.position">
      <span
        v-for="(page, index) in props.pages"
        :key="index"
        class="page"
        @click="handleClick(page)">
        {{ page }}
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue';
import { useClickOutside } from '@/composables';
import { MoreIcon } from '@/assets/icons';
import BaseSvg from '../../BaseSvg.vue';

export interface IHiddenPages {
  pages: number[];
  containerHeight?: string;
  position?: 'top' | 'bottom';
}

const props = withDefaults(defineProps<IHiddenPages>(), {
  containerHeight: '150px',
  position: 'top'
});

const emit = defineEmits(['onClick']);
const hiddenPages = useTemplateRef<HTMLDivElement>('hiddenPages');
const handleClick = (page: number) => {
  emit('onClick', page);
  showPagesContainer.value = false;
};
useClickOutside(hiddenPages, () => {
  showPagesContainer.value = false;
});
const showPagesContainer = ref(false);
</script>

<style scoped lang="scss">
.hidde-pages-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
  & .three-dots-icon {
    object-fit: none;
    cursor: pointer;
    padding: 8px 0;
  }
  & .pages-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    max-height: v-bind('props.containerHeight');
    min-width: 36px;
    overflow: auto;
    border: 1px solid #dadada;
    border-radius: $border-radius-sm;
    background: #f5f5f5;
    background:
      linear-gradient(#fff 33%, rgba(255, 255, 255, 0%)),
      linear-gradient(rgba(255, 255, 255, 0%), #fff 66%) 0 100%,
      radial-gradient(farthest-side at 50% 0, rgb(91, 87, 87, 30%), rgba(91, 87, 87, 3%)),
      radial-gradient(farthest-side at 50% 100%, rgb(91, 87, 87, 30%), rgba(91, 87, 87, 3%)) 0 100%;
    background-color: #fff;
    background-repeat: no-repeat;
    background-attachment: local, local, scroll, scroll;
    background-size:
      100% 63px,
      100% 63px,
      100% 12px,
      100% 12px;
    &.top {
      bottom: 20px;
    }
    &.bottom {
      top: 20px;
    }
    & .page {
      cursor: pointer;
      transition: all ease 0.3s;
      width: 100%;
      text-align: center;
      padding: 12px 0;
      font-weight: 600;
      &:hover {
        background: $disabled-light-200;
      }
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
